const PUBLIC_EMAIL_DOMAINS = new Set([
  // Consumer — wereldwijd
  'gmail.com', 'googlemail.com',
  'hotmail.com', 'hotmail.nl', 'hotmail.be', 'hotmail.co.uk', 'hotmail.fr', 'hotmail.de',
  'outlook.com', 'outlook.nl', 'outlook.be',
  'live.com', 'live.nl', 'live.be',
  'msn.com',
  'yahoo.com', 'yahoo.nl', 'yahoo.co.uk', 'yahoo.fr', 'yahoo.de', 'ymail.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com',
  'protonmail.com', 'proton.me', 'pm.me',
  'gmx.com', 'gmx.net', 'gmx.de', 'gmx.nl',
  'mail.com',
  'fastmail.com', 'fastmail.fm',
  'tutanota.com', 'tuta.io',
  'zoho.com',
  // NL-specifiek
  'kpnmail.nl', 'planet.nl', 'ziggo.nl', 'upcmail.nl', 'xs4all.nl',
  'home.nl', 'quicknet.nl', 'casema.nl', 'chello.nl',
  'telfort.nl', 'tele2.nl', 'solcon.nl',
  'wanadoo.nl', 'orange.nl',
  // Disposable / tijdelijk
  'mailinator.com', 'guerrillamail.com', 'tempmail.com', '10minutemail.com',
  'throwaway.email', 'trashmail.com', 'yopmail.com',
]);

export function isPublicEmailDomain(domain: string): boolean {
  return PUBLIC_EMAIL_DOMAINS.has(domain.toLowerCase().trim());
}

export function extractDomain(email: string): string | null {
  const parts = email.split('@');
  if (parts.length !== 2) return null;
  const raw = parts[1];
  if (!raw) return null;
  const domain = raw.toLowerCase().trim();
  return domain || null;
}
